var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import "./AttachmentModule.scss";

import { Module, ModuleLink, ModuleGrid, ModuleMedia, ModuleContent, ModuleHeader, ModuleBody, ModuleLabel, ModuleTitle, ModuleDescription, ModuleMetadata } from '../';

var ModuleAttachment = (_temp2 = _class = function (_Component) {
    _inherits(ModuleAttachment, _Component);

    function ModuleAttachment() {
        var _temp, _this, _ret;

        _classCallCheck(this, ModuleAttachment);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderMetadata = function () {
            var _this$props = _this.props,
                uniqueId = _this$props.uniqueId,
                commentCount = _this$props.commentCount;


            var metadata = [];

            if (uniqueId) {
                metadata.push('#' + uniqueId);
            }

            if (commentCount) {
                metadata.push(commentCount + " comments");
            }

            if (!metadata.length) {
                return false;
            }

            return React.createElement(ModuleMetadata, { metadata: metadata });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ModuleAttachment.prototype.render = function render() {
        var _props = this.props,
            uniqueId = _props.uniqueId,
            documentType = _props.documentType,
            url = _props.url,
            title = _props.title,
            description = _props.description,
            imageUrl = _props.imageUrl,
            label = _props.label;


        if (!url) {

            return React.createElement(
                Module,
                this.props,
                React.createElement(
                    ModuleGrid,
                    this.props,
                    React.createElement(ModuleMedia, this.props),
                    React.createElement(
                        ModuleContent,
                        null,
                        React.createElement(
                            ModuleHeader,
                            null,
                            React.createElement(ModuleTitle, { title: title }),
                            ' ',
                            ' '
                        ),
                        React.createElement(
                            ModuleBody,
                            null,
                            React.createElement(ModuleLabel, { label: label || documentType }),
                            this.renderMetadata()
                        )
                    )
                )
            );
        }

        return React.createElement(
            Module,
            this.props,
            React.createElement(
                ModuleGrid,
                this.props,
                React.createElement(
                    ModuleLink,
                    { url: url },
                    React.createElement(ModuleMedia, this.props),
                    React.createElement(
                        ModuleContent,
                        null,
                        React.createElement(
                            ModuleHeader,
                            null,
                            React.createElement(ModuleTitle, { title: title }),
                            ' ',
                            ' '
                        ),
                        React.createElement(
                            ModuleBody,
                            null,
                            React.createElement(ModuleLabel, { label: label || documentType }),
                            this.renderMetadata()
                        )
                    )
                )
            )
        );
    };

    return ModuleAttachment;
}(Component), _class.defaultProps = {
    moduleType: "attachment",
    moduleSize: "small"
}, _temp2);
ModuleAttachment.propTypes = process.env.NODE_ENV !== "production" ? {
    /** Unique ID */
    uniqueId: PropTypes.string,
    /** Image thumbnail */
    imageUrl: PropTypes.string,
    /** Title  */
    title: PropTypes.string,
    /** Description */
    description: PropTypes.string,
    /** Label */
    label: PropTypes.string,
    /** Array of metadata */
    metadata: PropTypes.array,
    /** Created at */
    createdAt: PropTypes.string,
    /** Updated at */
    updatedAt: PropTypes.string
} : {};


export default ModuleAttachment;